import React from 'react';
import Stack from '../../../../v2BaseComponents/Stack';
import { getFallbackForGenericString, getFallbackFromName, LoadableAvatar } from '../../../../v2BaseComponents/Avatar';
import Text from '../../../../v2BaseComponents/Text';
import Chip from '../../../../v2BaseComponents/Chip';
import { getIntl } from '../../../../../utils/intl';
import { getCareTeamMemberDescriptor } from '../../../../../utils/careTeamUtils';
import { getSpacing } from '../../../../../utils/spacing';
import urls from '../../../../../utils/urls';
import { APITypes } from '../../../../../primary-record-types';

const intl = getIntl('profile-collaborator-details-associated-care-team-member', {
    associatedCareTeamMember: 'Associated With:',
    support: 'Support',
    insurance: 'Insurance',
    provider: 'Provider',
});

type AssociatedCareTeamMemberProps = {
    medicalProfileId: string;
    associatedCareTeamMember: APITypes.medicalProfileService.CareTeamMemberDetails | undefined | null;
};

const AssociatedCareTeamMember: React.FC<AssociatedCareTeamMemberProps> = ({
    medicalProfileId,
    associatedCareTeamMember,
}) => {
    if (!associatedCareTeamMember) return null;

    const careTeamMemberDescriptor = getCareTeamMemberDescriptor(associatedCareTeamMember);
    const fallbackName =
        careTeamMemberDescriptor.type === 'name'
            ? getFallbackFromName(careTeamMemberDescriptor.firstName, careTeamMemberDescriptor.lastName)
            : getFallbackForGenericString(careTeamMemberDescriptor.text);
    const minimalDescriptor =
        careTeamMemberDescriptor.type === 'name'
            ? careTeamMemberDescriptor.firstName + ' ' + careTeamMemberDescriptor.lastName
            : careTeamMemberDescriptor.text;

    return (
        <Stack vertical fullWidth style={{ paddingLeft: getSpacing(8) }} space={getSpacing(2.5)}>
            <Text variant="h6">{intl('associatedCareTeamMember')}</Text>
            <Stack horizontal space={getSpacing(2.5)} align="center">
                <LoadableAvatar
                    size={'md'}
                    avatarUrl={urls.api.careTeamMembers.avatar(
                        medicalProfileId,
                        associatedCareTeamMember.careTeamMemberId,
                    )}
                    fallbackName={fallbackName}
                />
                <Stack vertical space={getSpacing(1)} justify="center">
                    <Text variant="body-1">{minimalDescriptor}</Text>
                    <Chip title={intl(associatedCareTeamMember.careTeamMemberType)} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default React.memo(AssociatedCareTeamMember);
